// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 717) return "static/chunks/717-e033931f679f8ba3.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"341":"b9b26c3f","538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"111":"8c3d8b6a22ce9a27","341":"2c6dbd7c783c6675","377":"04cc4f7ac08782c1","415":"67a6f87f942e05e5","538":"cd140c3d731aed86","642":"529a96012a6b79a6","767":"f972996417007120","983":"74000e5117bfeb38"}[chunkId] + ".js";
};